import React from 'react';
import clsx from "clsx";

export default class RoomGroupPresenterGeneral extends React.Component {

  constructor(props) {
    super(props)
  }
  
  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })
    return (
      <div className={tabClasses} id="general">
        <div className="col-sm-6" className='general'>
          <label>{`${I18n.t('room_group_identifier')}`}</label> <span className="ss-help help" title={I18n.t('identifier_helper_text')}></span>
          <br></br>
          <p>{this.props.identifier}</p>
        </div>
      </div>
    )
  }
}